import performance from 'react-native-performance';

import { EventName, addOnceEventListener } from 'utils/event-hub';

import { startTrace, stopTrace } from '../trace';
import { TraceName } from '../types';

// Monitors the time it takes from javascript start until the first marketing card or tile image is visible
// Note: this end to end trace will *include* any appflow downloads
// Adds a custom attribute based on whether appflow was initiated or not during the course of this trace
export const initializeFirstMarketingTileVisibleMonitor = () => {
  const traceName = TraceName.JAVASCRIPT_START_TO_FIRST_MARKETING_TILE_VISIBLE;

  addOnceEventListener(EventName.JAVASCRIPT_START, () => {
    performance.mark(EventName.JAVASCRIPT_START);
    startTrace(traceName);
  });

  addOnceEventListener(EventName.MARKETING_IMAGE_LOADED, async () => {
    performance.measure(traceName, EventName.JAVASCRIPT_START);
    stopTrace(traceName);
  });
};
